
import React from "react";
import MenuBar from "@/components/MenuBar";

const LaunchPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <MenuBar />
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-120px)]">
        <div className="max-w-md mx-auto p-4 text-center">
          <img src="/lovable-uploads/e3828476-db7b-404d-a2dc-824c8927f5bd.png" alt="Briefr Kommer Snart i 2025" className="mx-auto w-64 md:w-80" />
          <p className="mt-8 text-gray-400 text-lg"></p>
        </div>
      </div>
    </div>
  );
};
export default LaunchPage;
